import { updateLiquidityCashWithOtherBanksItemSettings } from '../../../app/api/generated/client';
import { queryKeys } from '../query-keys';
import { useLiquiditySettingsMutation } from './use-liquidity-settings-mutation';

export const useUpdateLiquidityCashWithOtherBanksItemSettings = () =>
    useLiquiditySettingsMutation({
        mutationFn: (payload) => updateLiquidityCashWithOtherBanksItemSettings({ body: payload, path: { id: payload.id! } }).then((result) => result.data!),
        settingsQueryKey: queryKeys.liquidityCashWithOtherBanksSettings,
        scope: 'item',
    });
